<div class="campanha-roi-widgets">   
    <p class="text-muted" *ngIf="isLoading">
        <i class='fas fa-spinner fa-pulse'></i> Carregando resultados
    </p>   
    
    <ng-template [ngIf]="!isLoading">
        <div class="campanha-roi-widget">
            <sgt-campanha-roi-widget-recurso
                [isLoading]="isLoading"
                [valorTotalRecursos]="valorTotalRecursos">
            </sgt-campanha-roi-widget-recurso>
        </div>

        <div class="campanha-roi-widget">
            <sgt-campanha-roi-widget-resultado
                [isLoading]="isLoading"
                [valorTotalResultado]="valorTotalResultado">
            </sgt-campanha-roi-widget-resultado>
        </div>
        
        <div class="campanha-roi-widget">
            <sgt-campanha-roi-widget-roi
                [isLoading]="isLoading"
                [roi]="roi">
            </sgt-campanha-roi-widget-roi>
        </div>        
    </ng-template>  
</div>